// extracted by mini-css-extract-plugin
export default {"main":"tv_series_main__FXUjL","title":"tv_series_title__mVjgv","items":"tv_series_items__VLFFu","item":"tv_series_item__8dkbW"};